import SearchTree from './SearchTree.vue'
export default SearchTree
